import { AxiosBaseApi } from '@config/axios.config'
import { ENDPOINTS } from '@constants'
import { ICustomerProfile } from '@typings'
import { AxiosRequestConfig, AxiosResponse } from 'axios'

export class CustomerApi extends AxiosBaseApi {
  get_list = (params?: AxiosRequestConfig['params']) =>
    this.api
      .get<AxiosResponse<{ data: any[] }>>(ENDPOINTS.CUSTOMERS.LIST(), { params })
      .then(res => res.data.data)

  getSingle = (id: number) =>
    this.api
      .get<AxiosResponse<{ data: any }>>(ENDPOINTS.CUSTOMER.SINGLE(id))
      .then(res => res.data.data)

  getProfile = (id: ICustomerProfile['customer_id']) =>
    this.api
      .get<AxiosResponse<{ data: ICustomerProfile }>>(
        ENDPOINTS.CUSTOMER.PROFILE_SINGLE(id)
      )
      .then(res => res.data.data)

  updateProfile = (id: ICustomerProfile['id'], data: ICustomerProfile) =>
    this.api
      .post<AxiosResponse<{ data: ICustomerProfile }>>(
        ENDPOINTS.CUSTOMER.SINGLE(id),
        data
      )
      .then(res => res.data.data)
}
